// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qxbp","label":"styles_label__JrwKL"};